var _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3173_26944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2899 11.4238C20.2899 11.4238 20.1785 10.6375 19.8354 10.2925C19.4012 9.83804 18.9156 9.8359 18.693 9.80906C17.0984 9.69336 14.7041 9.69336 14.7041 9.69336H14.6994C14.6994 9.69336 12.3053 9.69336 10.7105 9.80906C10.4877 9.8359 10.0023 9.83804 9.5678 10.2925C9.22522 10.6375 9.11594 11.4238 9.11594 11.4238C9.11594 11.4238 9 12.348 9 13.2703V14.1343C9 15.0566 9.11356 15.9807 9.11356 15.9807C9.11356 15.9807 9.22498 16.7671 9.56566 17.1123C9.99994 17.5665 10.5701 17.5511 10.8241 17.6C11.7373 17.687 14.7017 17.7136 14.7017 17.7136C14.7017 17.7136 17.0981 17.7091 18.693 17.5955C18.9158 17.5689 19.4012 17.5665 19.8357 17.1123C20.1785 16.7671 20.2899 15.9807 20.2899 15.9807C20.2899 15.9807 20.4035 15.0589 20.4035 14.1345V13.2705C20.4035 12.3485 20.2899 11.4241 20.2899 11.4241V11.4238ZM13.5234 15.1834V11.9786L16.6035 13.5865L13.5234 15.1834V15.1834Z",
    fill: "#0F0F0F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 14.3463,
    cy: 13.5416,
    r: 13.0019,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.07956
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3173_26944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4035,
    height: 11.4035,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.b990af7f07224f55586185de1993cf6b.svg";
export { ForwardRef as ReactComponent };